import { AddButton } from "app/components/Button/AddButton";
import { ThreedotIcon } from "app/icons";
import React from "react";
import { useTranslation } from "react-i18next";

import { useStyles } from "./style";

type Props = {
  onAddClick?: () => void;
};

const ActionBar = ({ onAddClick }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <div className={styles.root} dir="ltr">
      <div className={styles.actions}>
        <AddButton
          label={t("MANUFACTURERS.ACTIONS.ADD_MANUFACTURER")}
          onClick={onAddClick}
        />
      </div>
    </div>
  );
};

export default ActionBar;
